import React, { useEffect, useRef } from 'react';
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Icon } from '@iconify/react';

const FieldTooltip = ({ content }) => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    const tooltip = new Tooltip(tooltipRef.current, {
      trigger: 'hover',
      html: true,
      placement: 'right', // ✅ Proper tooltip position
      title: content,
      customClass: 'tooltip-field-helper',
    });

    return () => tooltip.dispose();
  }, [content]);

  return (
    <span
      ref={tooltipRef}
      role="button"
      tabIndex={0}
      style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '0.4rem' }}
    >
      <Icon icon="mdi:information-outline" width="16" height="16" style={{ color: "#6c757d", cursor: "pointer" }} />
    </span>
  );
};

export default FieldTooltip;